import { Faq } from "@/types/faq";
import { useNavigate } from "react-router-dom";
import { useFaqSearch } from "@/stores/faqSearch";
import * as Common from "@/utils/common";
import React from "react";
import {CustomMarkdown} from "@/components/CustomMarkdown";

export const ResultItem = ( { faq, index }: { faq: Faq, index: number } ) => {
  const navigate = useNavigate();
  const { setBackPage } = useFaqSearch();
  const onClickDetail = () => {
    setBackPage("/faq_search");
    navigate(`/faq/${faq.data_id}`);
  };

  return (
    <div
      className="faq-search-result-item"
      key={index}
      onClick={onClickDetail}
    >
      <div className="uk-flex">
        <p className="uk-text-medium-s uk-text-bold">{faq.display_num}</p>
        <p className="uk-text-medium-s uk-text-bold margin-left-24">
          {faq.title}
        </p>
      </div>
      <div className="description">
        <p className="uk-text-default description-question"><CustomMarkdown content={faq?.question}/>
        </p>
        <p className="uk-text-default description-answer"><CustomMarkdown content={faq?.answer}/></p>
      </div>
      <div className="uk-flex uk-flex-between uk-margin-top margin-left-32">
        <div className="uk-flex">
          <div className="uk-flex uk-flex-middle width-175">
            <p className="tag-dark">管理番号</p>
            <p className="uk-text-default margin-left-16">{Common.controlNum(faq.data_id)}</p>
          </div>
          <div className="uk-flex uk-flex-middle width-175">
            <p className="tag-dark">更新日</p>
            <p className="uk-text-default margin-left-27">{faq.modified}</p>
          </div>
        </div>
        <div className="uk-flex uk-flex-wrap gap-10 uk-margin-small-right">
          {faq.faq_type.map(( type, i ) => (
            <p key={i} className="tag-light">{type.name}</p>
          ))}
          {faq.faq_kind.map(( kind, i ) => (
            <p key={i} className="tag-light">{kind.name}</p>
          ))}
        </div>
      </div>
    </div>
  );
};